import * as PriceOfferListActions from '../actionTypes/priceOfferListActionTypes';
import sortOrderTypes from '../../constants/sortOrderTypes';
import { selectSortedAndFilteredPackages } from '../selectors/priceOfferListSelectors';
import { pushToDataLayer, getProductFieldObject } from '../../utils/gtmLogUtils';

const sortOrderTypeToEventLabel = {
  [sortOrderTypes.earliestDate]: 'D',
  [sortOrderTypes.lowestPrice]: 'LP',
  [sortOrderTypes.highestRating]: 'HR',
};


const logFilterEvent = (filterCategory, numberOfHits, isCharter, filterValue) => {
  pushToDataLayer({
    eventCategory: 'Travel',
    eventAction: 'PO List Filter',
    eventLabel: filterCategory,
    event: 'Filter',
    travelAction: 'Filter',
    travelHits: numberOfHits,
    travelType: isCharter ? 'CharterPackage' : 'IndependentPackage',
    travelFilterSet: 'Price Offer List',
    travelFilterCategory: filterCategory,
    travelFilterValue: filterValue,
  });
};

const logProductImpressions = (productImpressions) => {
  pushToDataLayer({ ecommerce: null }); // Clear the previous ecommerce object as recommended by Google.
  pushToDataLayer({
    event: 'productImpression',
    ecommerce: {
      impressions: productImpressions,
    },
  });
};

export const GTMLoggerMiddleware = store => next => (action) => { // eslint-disable-line no-unused-vars
  next(action); // Must do this before logging to get the correct number of hits after filter

  const actionType = action.type;
  switch (actionType) {
    case PriceOfferListActions.SET_SORT_ORDER:
      pushToDataLayer({
        eventCategory: 'Price Offer List',
        eventAction: 'Sort',
        eventLabel: sortOrderTypeToEventLabel[action.sortOrder],
        event: 'priceofferlistSort',
      });
      break;
    case PriceOfferListActions.ADD_DEPARTURE_MONTH_FILTER: {
      const storeState = store.getState();
      const { isCharter } = storeState.priceOfferList;
      const actionMonthString = action.monthToAdd.toString();
      const numberOfHits = selectSortedAndFilteredPackages(storeState).length;
      const filterValue = `${actionMonthString.slice(0, 4)}-${actionMonthString.slice(4)}`;

      logFilterEvent('Departure Month', numberOfHits, isCharter, filterValue);
      break;
    }
    case PriceOfferListActions.ADD_DEPARTURE_AIRPORT_FILTER: {
      const storeState = store.getState();
      const { isCharter } = storeState.priceOfferList;
      const numberOfHits = selectSortedAndFilteredPackages(storeState).length;
      const filterValue = action.airportToAdd;

      logFilterEvent('Departure Code', numberOfHits, isCharter, filterValue);
      break;
    }
    case PriceOfferListActions.ADD_DESTINATION_FILTER: {
      const storeState = store.getState();
      const { isCharter } = storeState.priceOfferList;
      const numberOfHits = selectSortedAndFilteredPackages(storeState).length;
      const filterValue = action.destinationToAdd.id;
      const filterCategory = action.destinationToAdd.type;

      logFilterEvent(filterCategory, numberOfHits, isCharter, filterValue);
      break;
    }
    case PriceOfferListActions.SET_MAX_PRICE_FILTER: {
      const storeState = store.getState();
      const { isCharter } = storeState.priceOfferList;
      const numberOfHits = selectSortedAndFilteredPackages(storeState).length;
      const filterValue = action.maxPrice;

      logFilterEvent('Max Price', numberOfHits, isCharter, filterValue);
      break;
    }
    case PriceOfferListActions.INIT_SUCCESS: {
      const storeState = store.getState();
      const { isCharter } = storeState.priceOfferList;
      const packages = selectSortedAndFilteredPackages(storeState);

      const productImpressions = packages.map((pkg, index) => {
        const { departureAirportCodeOrWvId, destinationAirportCodeOrWvId, hotelCode, hotelProductName, price } = pkg;
        return getProductFieldObject(
          departureAirportCodeOrWvId,
          destinationAirportCodeOrWvId,
          hotelCode,
          price,
          hotelProductName,
          isCharter,
          index,
        );
      });
      logProductImpressions(productImpressions);
      break;
    }
    default:
  }
};
